<div class="headline">
  <span>{{ 'general.rule-engine-headline-prefix' | translate }}</span>
  <coin-rule-engine-condition-picker
    [currentCondition]="viewValue().condition"
    (changed)="setCondition($event)"></coin-rule-engine-condition-picker>
  <span>{{ 'general.rule-engine-headline-postfix' | translate }}</span>
</div>

@for (ruleOrRuleSet of viewValue().rules; track ruleOrRuleSet) {
  @if (isRuleSet(ruleOrRuleSet)) {
    <coin-lightweight-rule-set
      [ruleSet]="ruleOrRuleSet"
      (delete)="deleteItem(ruleOrRuleSet)"></coin-lightweight-rule-set>
  } @else {
    <coin-lightweight-rule
      [rule]="ruleOrRuleSet"
      (delete)="deleteItem(ruleOrRuleSet)"></coin-lightweight-rule>
  }
}

<div class="buttons">
  @if (!disabled()) {
    <coin-v2-button
      icon="add"
      type="secondary"
      [text]="'general.rule-engine-add-rule' | translate"
      (click)="addRule()"></coin-v2-button>
  }
  @if (!disabled() && allowRuleSets() !== 'none') {
    <coin-v2-button
      icon="add"
      type="secondary"
      [text]="'general.rule-engine-add-rule-set' | translate"
      (click)="addRuleSet()"></coin-v2-button>
  }
  <ng-container *ngTemplateOutlet="additionalFooterButtons()"></ng-container>
</div>
